import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { workspace_userActions } from "../../../actions";
import { Container } from "react-bootstrap";
import { history } from "../../../helpers";
import { PopupAlert } from "../../../components/PopupAlert";
import { userConstants } from "../../../constants";

const DeclineInvitation = () => {
  const { access_token } = useParams();
  const dispatch = useDispatch();
  const [finished, setFinished] = useState(false);
  const [declined, setDeclined] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if(access_token){
      const successFunc = () => {
        setDeclined(true);
      }

      const finalFunc = () => {   
        setFinished(true);
      }

      const errorFunc = (error) => { 
        setError(error);
      }

      dispatch(workspace_userActions.declineInvitationByToken(access_token, successFunc, errorFunc, finalFunc))
    }

    return () => {
      
    };
  }, []);

  const goToHome = () => {
    history.push('/')
  }
  
  return (
    <Container>
      {
        finished && (
          declined ? (
            <PopupAlert
              show={true}
              handleSubmit={goToHome}
              handleClose={goToHome}
              display_text={userConstants.DECLINE_INVITATION}
            />
          ) : (
            <PopupAlert
              show={true}
              handleSubmit={goToHome}
              handleClose={goToHome}
              display_text={ error ? error : userConstants.DECLINE_INVITATION_FAILURE}
            />
          )
        )
      }
    </Container>
  );
};

export default DeclineInvitation;